import React from "react";
import KeyboardAltIcon from "@mui/icons-material/KeyboardAlt";


const Logo = ({ isFocusedMode }) => {

  return (
    <div className="header" style={{visibility: isFocusedMode ? 'hidden' : 'visible' }}>

      <h1 style={{ fontFamily: 'EXO' }}>
        GARAACE
      </h1>
      <span className="sub-header">
        Afkaaga Hooyo Ku Baro Typing-ka
      </span>
    </div>
  );
};

export default Logo;
